import React from "react";
import { brands } from "../mock";

export default function Brands() {
  const loop = [...brands, ...brands];
  return (
    <section className="border-y border-navy/10 bg-white py-10">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <p className="mb-6 text-center text-xs font-bold uppercase tracking-[0.25em] text-navy/40">
          Trusted brands we stock
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
          {loop.slice(0, brands.length).map((b, i) => (
            <span
              key={i}
              className="font-heading text-xl font-extrabold tracking-wide text-navy/30 transition-colors hover:text-navy"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
